import { z } from 'zod';

const PASSWORD_RESET_MIN_LENGTH = 12;
export const OTP_LENGTH = 6;

type NewPasswordSchemaTexts = {
  passwordRequired: string;
  passwordMinLength: string;
  confirmPasswordRequired: string;
  passwordsDontMatch: string;
};

const passwordFields = (texts: NewPasswordSchemaTexts) => ({
  password: z.string().min(1, texts.passwordRequired).min(PASSWORD_RESET_MIN_LENGTH, texts.passwordMinLength),
  confirmPassword: z.string().min(1, texts.confirmPasswordRequired)
});

const passwordsMatch = (data: { password: string; confirmPassword: string }) => data.password === data.confirmPassword;

export const createNewPasswordSchema = (texts: NewPasswordSchemaTexts) =>
  z
    .object(passwordFields(texts))
    .refine(passwordsMatch, { message: texts.passwordsDontMatch, path: ['confirmPassword'] });

type CurrentPasswordSchemaTexts = {
  currentPasswordRequired: string;
};

export const createCurrentPasswordSchema = (texts: CurrentPasswordSchemaTexts) =>
  z.object({
    currentPassword: z.string().min(1, texts.currentPasswordRequired)
  });

type OtpPasswordSchemaTexts = NewPasswordSchemaTexts & {
  codeRequired: string;
};

export const createOtpPasswordSchema = (texts: OtpPasswordSchemaTexts) =>
  z
    .object({
      otpCode: z.string().length(OTP_LENGTH, texts.codeRequired),
      ...passwordFields(texts)
    })
    .refine(passwordsMatch, { message: texts.passwordsDontMatch, path: ['confirmPassword'] });

type EmailSchemaTexts = {
  invalidEmail: string;
};

export const createEmailSchema = (texts: EmailSchemaTexts) => z.object({ email: z.email(texts.invalidEmail) });

type EmailLoginSchemaTexts = EmailSchemaTexts & {
  passwordRequired: string;
};

export const createEmailLoginSchema = (texts: EmailLoginSchemaTexts) =>
  createEmailSchema(texts).extend({ password: z.string().min(1, texts.passwordRequired) });
